import React, { useEffect, useRef, useState } from 'react';
import styles from './CategoryTreeBreadcrumb.module.less';
import Icon from '../../Icon';
import PropTypes from 'prop-types';
import clsx from 'clsx';
const CategoryTreeBreadcrumb = ({
  breadcrumbNodes,
  onClick,
  contentRequestInProcess,
}) => {
  const scrollContainerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [scrolledToEnd, setScrolledToEnd] = useState('');
  const handleClick = (e, href) => {
    if (e.type !== 'click' && e.key !== 'Enter') {
      return;
    }

    onClick(e, href);
  };

  const handleResize = () => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer != null) {
      // Check if div is overflowing horizontally
      if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
        setIsOverflowing(true);
        // Scroll to end
        scrollContainer.scrollLeft = scrollContainer.scrollWidth;
      } else {
        setIsOverflowing(false);
      }
    }
  };

  // Scroll last child (selected/parent category) into view on load + when nodes change
  useEffect(() => {
    handleResize();
  }, [breadcrumbNodes]);

  // Scroll last child (selected/parent category) into view on resize
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (scrollContainer.scrollLeft === 0) {
        setScrolledToEnd('left');
      } else if (
        scrollContainer.scrollLeft >=
        scrollContainer.scrollWidth - scrollContainer.clientWidth
      ) {
        setScrolledToEnd('right');
      } else {
        setScrolledToEnd('');
      }
    };
    if (scrollContainer != null) {
      scrollContainer.addEventListener('scroll', handleScroll);
    }
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [scrollContainerRef]);

  const handleClickScrollArrow = (e, dir) => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer != null) {
      if (dir === 'left') {
        scrollContainer.scrollLeft -= scrollContainer.scrollWidth;
      } else if (dir === 'right') {
        scrollContainer.scrollLeft = scrollContainer.scrollWidth;
      }
    }
  };

  const classes = clsx(styles.breadcrumb, {
    [styles.disabled]: contentRequestInProcess,
  });

  return (
    <div className={styles.container}>
      {isOverflowing && scrolledToEnd !== 'left' && (
        <button
          className={clsx(styles.scrollButton, styles.leftSide)}
          onClick={e => handleClickScrollArrow(e, 'left')}
        >
          <Icon name="left-open" className={styles.scrollArrow} />
        </button>
      )}
      <div className={styles.scrollContainer} ref={scrollContainerRef}>
        <img
          src="https://cdn.education.com/files/static/content/breadcrumbs_icon.svg"
          alt=""
          height="30"
          width="30"
        />
        {breadcrumbNodes.map((breadcrumb, idx) => {
          return (
            <React.Fragment key={idx}>
              <a
                className={classes}
                key={breadcrumb.display}
                href={breadcrumb.href}
                onClick={e => handleClick(e, breadcrumb.href)}
              >
                {breadcrumb.display}
              </a>
              {idx < breadcrumbNodes.length - 1 && (
                <Icon name="right-open" className={styles.separatorArrow} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {isOverflowing && scrolledToEnd !== 'right' && (
        <button
          className={clsx(styles.scrollButton, styles.rightSide)}
          onClick={e => handleClickScrollArrow(e, 'right')}
        >
          <Icon name="right-open" className={styles.scrollArrow} />
        </button>
      )}
    </div>
  );
};

CategoryTreeBreadcrumb.propTypes = {
  breadcrumbNodes: PropTypes.array,
  onClick: PropTypes.func,
  contentRequestInProcess: PropTypes.bool.isRequired,
};

export default CategoryTreeBreadcrumb;
